angular.module('qkr.refund').controller('transRefundHistoryController', ($scope, $uibModalInstance, transService, transId, currency) => {
    $scope.loading = true;
    $scope.currency = currency;

    const init = function() {
        transService.getTransRefundHistory(transId).then((response) => {
            $scope.transRefundHistories = response;
            $scope.loading = false;
        });
    };

    $scope.confirm = function() {
        $uibModalInstance.close('ok');
    };

    init();
});



// WEBPACK FOOTER //
// ./src/refund/controllers/modal/trans.refund.history.controller.js